export const environment = {
  production: true,
  apiUri: '__CDN_URL_ROOT_API__',
  publicUrl: '__CDN_URL_ROOT_PUBLIC__',
  baseUrl: '__CDN_URL_ROOT_API__'
};
